import { queryOptions } from '@tanstack/react-query'
import getApiResponseData from '@utils/get-api-response-data'

import { api } from '../api'
import { key } from './key'

const DAY_IN_MS = 24 * 60 * 60 * 1000

export const getList = () =>
  queryOptions({
    queryKey: key('list'),
    queryFn: async () => {
      const { data } = await api.getList()
      const districts = getApiResponseData(data)?.federal_districts

      if (!districts?.length) {
        throw new Error('federal districts request returned no items')
      }

      return districts
    },
    // Перечень неизменный: одного повтора хватает для редкого сбоя, а дальнейшие только задерживают отказ.
    retry: 1,
    staleTime: DAY_IN_MS,
    gcTime: DAY_IN_MS,
  })
